<app-page>
  <transfer-deso></transfer-deso>
</app-page>
